import React from "react";
import ReactDOM from "react-dom";
import Toast from "./Toast";

const toast = document.getElementById("Toast");

if (toast) {
  ReactDOM.render(<Toast />, toast);
}
